import { Observable, of, throwError } from 'rxjs';
import { endpoints } from '@app/constants';
import { mergeMap, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { UpdateCreditCardPayload, UpdateCreditCardResponse } from './update-credit-card.models';
import { HttpService } from '@app/core/services/http';

@Injectable({
  providedIn: 'root'
})
export class UpdateCreditCardService {
  constructor(
    private httpService: HttpService,
  ) { }

  public updateCreditCard = (payload: UpdateCreditCardPayload): Observable<UpdateCreditCardResponse> => {
    return this.httpService
      .post({ url: `${endpoints.zuora}${endpoints.account}${endpoints.update}`, body: payload})
      .pipe(
        mergeMap(this.handleUpdateCreditCard),
        catchError(err => {
          return throwError(err);
        })
      );
  }

  private handleUpdateCreditCard(response: UpdateCreditCardResponse): Observable<UpdateCreditCardResponse> {
    return of(response);
  }

}
